"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MarginBalancesTableHeader = require("./MarginBalancesTableHeader");
Object.keys(_MarginBalancesTableHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MarginBalancesTableHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MarginBalancesTableHeader[key];
    }
  });
});